"use client";

import React from "react";
import { Button } from "../ui/button";

interface QuantitySelectorProps {
  value: number;
  onChange: (newQuantity: number) => void;
  min?: number;
  max?: number;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void; // ✅ ADD THIS
}

const QuantitySelector: React.FC<QuantitySelectorProps> = ({
  value,
  onChange,
  min = 1,
  max = Infinity,
  className = "",
  onClick,
}) => {
  const handleDecrease = () => {
    onChange(Math.max(min, value - 1));
  };

  const handleIncrease = () => {
    onChange(Math.min(max, value + 1));
  };

  return (
    <div
      className={`flex items-center border rounded-md ${className}`}
      onClick={onClick}
    >
      <Button
        type="button"
        variant="ghost"
        onClick={handleDecrease}
        disabled={value <= min}
        className="h-8 w-8 md:h-9 md:w-9 p-0 text-lg md:text-lg font-semibold cursor-pointer"
      >
        –
      </Button>

      <div className="min-w-[28px] md:min-w-[40px] text-center text-sm md:text-base font-medium px-1">
        {value}
      </div>

      <Button
        type="button"
        variant="ghost"
        onClick={handleIncrease}
        disabled={value >= max}
        className="h-8 w-8 md:h-9 md:w-9 p-0 text-lg md:text-lg font-semibold cursor-pointer"
      >
        +
      </Button>
    </div>
  );
};

export default QuantitySelector;
